'use client';

import type { ReactNode } from 'react';
import { NotificationBannerProvider } from '@/features/notifications/banner-context';

export { PublicHeader } from '@/features/notifications/header';
export type { PublicHeaderProps } from '@/features/notifications/header';

/** 通知是公开区域的业务能力，不属于基础 AppProviders。 */
export function PublicNotifications({ children }: { /** 公开页面。 */ children: ReactNode }) {
    return (
        <NotificationBannerProvider>{children}</NotificationBannerProvider>
    );
}
